import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDivComponent } from './modal-div.component';
import { TranslationModule } from 'src/app/i18n/translation.module';



@NgModule({
  declarations: [
    ModalDivComponent
  ],
  imports: [
    CommonModule,
    TranslationModule
  ],
  exports: [ModalDivComponent]
})
export class ModalDivModule { }
